import { useEffect } from "react";
import app from "nystem";
import devicePosition from "../../client/devicePosition";

const MapDevicePos = ({ model }) => {
  useEffect(() => devicePosition({ app, model, navigator, window }), [model]);
  return null;
};

export default MapDevicePos;
